
import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

// Save Supplier Info
export async function addOrUpdateToCart(addToCartDTO) {
  try{
    
   return axiosInstance.post(`${backendUrl}/api/cart/add`, addToCartDTO);
    
    } catch (err) {
  throw err;
}
}
/*export async function addOrUpdateToCart(addToCartDTO) {
axiosInstance
  .post(`${backendUrl}/api/cart/add`, addToCartDTO)
  .then(res => {
    console.log("Success:", res.data);
  return res;
  })
  .catch(err => {
    if (err.response) {
      alert(err.response.data.message || "Bad Request");
    } else {
      alert("Network error");
    }
  });
  return;
}*/

 

// Call to fetch supplier info 
export async function getCarts(userId) {
  return axiosInstance.get(`${backendUrl}/api/cart/items/user/${userId}`); // or whatever your API is
}

/*
const addOrUpdateToCart = (productId, quantity) => {
     const addToCartDTO = {
                userId: 1, // Replace with logged-in user ID
                productId: productId,
                quantity: quantity
            };
  return fetch(`/api/cart/add`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ productId, quantity }),
  });
};*/

const removeFromCart = (productId) => {
  return fetch(`/api/cart/${productId}`, {
    method: 'DELETE',
  });
};


// Save cart 
export async function updateCartTotal(cartDTO) {

  return axiosInstance.post(`${backendUrl}/api/cart`, cartDTO);
}


export async function updateSlotSelection(cartDTO) {

  return axiosInstance.post(`${backendUrl}/api/cart/slotSelection`, cartDTO);
}



// Call to fetch supplier info 
export async function getUserCart(userId) {
  return axiosInstance.get(`${backendUrl}/api/cart/user/${userId}`); // or whatever your API is
}

export default { addOrUpdateToCart, removeFromCart,getCarts, updateCartTotal, updateSlotSelection, getUserCart };